export default {
	header: {
		height: '60px'
	},
	footer: {
		height: '56px'
	}
};
